export default __webpack_public_path__ + "static/media/before_image.1f26559e.png";